import backdropImage from './images/backdrop.jpg';
import bottomsImage from './images/bottoms.png';
import headwearImage from './images/headwear.png';
import itemsImage from './images/items.png';
import petsImage from './images/pets.png';
import skinsImage from './images/skins.png';
import specialStoreImage from './images/special_store.png';
import topsImage from './images/tops.png';

export const BOOMER_ITEM_CATEGORIES = [
    {
        key: 'skins',
        name: 'Skins',
        itemName: 'Skin',
        itemType: 1,
        type: 'body',
        image: skinsImage,
    },
    {
        key: 'headwear',
        name: 'Headwear',
        itemName: 'Headwear',
        itemType: 2,
        type: 'hair',
        image: headwearImage,
    },
    {
        key: 'tops',
        name: 'Tops',
        itemName: 'Top',
        itemType: 3,
        type: 'top',
        image: topsImage,
    },
    {
        key: 'bottoms',
        name: 'Bottoms',
        itemName: 'Bottom',
        itemType: 4,
        type: 'bottom',
        image: bottomsImage,
    },
    {
        key: 'pets',
        name: 'Pets',
        itemName: 'Pet',
        itemType: 6,
        type: 'pet',
        image: petsImage,
    },
    {
        key: 'items',
        name: 'Items',
        itemName: 'Item',
        itemType: 5,
        type: 'accessory',
        image: itemsImage,
    },
    {
        key: 'backdrop',
        name: 'Backdrop',
        itemName: 'Backdrop',
        itemType: 7,
        type: 'backdrop',
        image: backdropImage,
        rounded: true,
    },
    {
        key: 'specialStore',
        name: 'Special Store',
        itemName: 'Special Item',
        itemType: 8,
        type: 'special_store',
        image: specialStoreImage,
    },
];

export const getBoomerItemCategory = (key) =>
    BOOMER_ITEM_CATEGORIES.find((category) => category.key === key);

export const DEFAULT_COORDINATES = {
    1: { y: 0, x: 0 },
    2: { y: -73, x: 0 },
    3: { y: 276, x: 0 },
    4: { y: 412, x: 0 },
    5: { y: 281, x: 83 },
    6: { y: 305, x: -165 },
};
